import React, { useRef, useEffect, useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Auth } from "aws-amplify";
import { CognitoHostedUIIdentityProvider } from "@aws-amplify/auth";
import { useHistory } from "react-router-dom";
import validate from "../../../utils/validate";
import "../styles.scss";

import LogoSmall from "../../../assets/images/logo-small.png";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import DescriptionIcon from "@material-ui/icons/Description";
import Logo from "../../../assets/images/logo_transparent.png";
import { Button, CssBaseline, TextField, Link, Paper, Grid, Typography, Divider } from "@material-ui/core";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import Copyright from "../Copyright";

import { AllProps } from "./LoginContainer";
import { getHeaders, setHeaders } from "../../../redux/utils";

function Alert(props: AlertProps) {
	return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const GoogleIcon = () => (
	<svg className="googleIcon" width="18" height="18" viewBox="0 0 48 48" aria-hidden="true">
		<path
			fill="#EA4335"
			d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
		/>
		<path
			fill="#4285F4"
			d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
		/>
		<path
			fill="#FBBC05"
			d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
		/>
		<path
			fill="#34A853"
			d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
		/>
	</svg>
);

const Login = (props: AllProps) => {
	const history = useHistory();
	const { loadingError } = props.auth;
	const { storeSession } = props;

	const emailRef: any = useRef("");
	const passwordRef: any = useRef("");

	const [credentials, setCredentials] = useState({
		email: "",
		password: "",
		emailConfirmationCode: "",
	});
	const [errors, setErrors] = useState({} as any);

	useEffect(() => {
		if (props.auth.user) {
			Auth.currentSession()
				.then((r: any) => {
					storeSession(r);
				})
				.catch((e) => {
					console.error(e);
				});
		}
	}, [props.auth.user, storeSession]);

	const handleChange = (e: any) => {
		const { name, value } = e.target;
		setCredentials({
			...credentials,
			[name]: value,
		});
	};
	const handleLogin = (e: any) => {
		e.preventDefault();
		const validation = validate("login", credentials);
		setErrors({
			...errors,
			email: validation.email,
			password: validation.password,
		});
		if (validation.email === undefined && validation.password === undefined) {
			doLogin();
		}
	};
	const handleFederatedLogIn = (e: any, provider: "azure-ad" | "Google") => {
		e.preventDefault();
		const signIn =
			provider === "Google" ? Auth.federatedSignIn({ provider: CognitoHostedUIIdentityProvider.Google }) : Auth.federatedSignIn({ customProvider: "azure-ad" });
		signIn.catch((err: any) => {
			console.log(err);
		});
	};
	const doLogin = () => {
		const escapeEmails = [
			"PAhayas581@990ys.com",
			"Aryano2009@hotmail.com",
			"C_D_Melanson@hotmail.com",
			"Education@upstatetraining.com",
			"Phylwon@aol.com",
			"President@hta-ca.org",
			"Townsvillepig@gmail.com",
		];
		const email = escapeEmails.find((email: string) => email.toLowerCase() === emailRef.current.value.toLowerCase());
		const values = {
			username: email ? escapeEmails[escapeEmails.indexOf(email)] : emailRef.current.value.toLowerCase(),
			password: passwordRef.current.value,
		};
		emailRef.current.value = "";
		passwordRef.current.value = "";

		props.login(values);
	};

	// In case the user did not confirm his email earlier
	const confirmRegister = (e: any) => {
		e.preventDefault();
		const userData = {
			Username: props.showConfirmEmail,
			ConfirmationCode: credentials.emailConfirmationCode,
		};

		props.confirmSignUp(userData).then(() => {
			props.login({ username: props.showConfirmEmail, password: credentials.password }).then((r: any) => {
				history.push("/dashboard");
				Auth.currentSession().then((r: any) => {
					localStorage.setItem("jwt", r.accessToken.jwtToken);
					localStorage.setItem("jwt", r.idToken.jwtToken);
					setHeaders({
						"Content-Type": "application/json",
						Authorization: `Bearer ${r.accessToken.jwtToken}`,
						IdToken: r.idToken.jwtToken,
					});
					props.storeSession(r).then(() => {});
				});
			});
		});
	};

	return (
		<div>
			<Grid container component="main" className="root login">
				<CssBaseline />
				<Grid item xs={12} sm={4} md={4} lg={4} className="image">
					<a href="https://gutenbergcerts.com" style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "30px 30px 0" }}>
						<img style={{ width: "100%" }} src={Logo} alt="gutenberg cert logo" className="CertLogo" />
					</a>
					<div className="cert-steps" style={{ display: "none" }}>
						<Typography component="h1" variant="h5">
							Create your certificate <br /> in 3 Easy Steps
						</Typography>
						<div className="step">
							<CloudUploadIcon className="icon red" />
							<Typography component="h2">
								<b>Step 1: </b> Create/Select Template
							</Typography>
						</div>
						<div className="step">
							<MailOutlineIcon className="icon red" />
							<Typography component="h2">
								<b>Step 2: </b> Upload Recipients
							</Typography>
						</div>
						<div className="step">
							<DescriptionIcon className="icon red" />
							<Typography component="h2">
								<b>Step 3: </b> Send Certificates
							</Typography>
						</div>
					</div>
				</Grid>
				<Grid item xs={12} sm={8} md={8} lg={8} component={Paper} elevation={6} square className="flex right-side">
					<div className="paper">
						<section className="topside">
							<div className="title">
								<img src={LogoSmall} alt="small logo" className="small-logo hidden" />
								{props.showConfirmEmail ? (
									<section>
										<Typography component="h1" variant="h5">
											Confirm your email address
										</Typography>
										<Typography component="h2" className="red mt-25">
											Please enter the confirmation code recived at your email address
										</Typography>
									</section>
								) : (
									<section>
										<Typography component="h1" variant="h5">
											Log in to Your Account
										</Typography>
										<Typography component="h2">
											New to this site?
											<Link component={RouterLink} to="/register" className="red bold signup">
												Sign up
											</Link>
										</Typography>
									</section>
								)}
							</div>

							{loadingError && (
								<Alert className="banner" severity="error">
									{loadingError && loadingError.message}
								</Alert>
							)}
							{props.showConfirmEmail ? (
								<Grid container spacing={2} style={{ marginTop: "5px" }} className="form">
									<Grid item xs={12}>
										<TextField
											disabled
											error={errors.email ? true : false}
											value={props.showConfirmEmail}
											onChange={(e) => handleChange(e)}
											id={errors.email ? "outlined-error-helper-text" : "email"}
											label={errors.email ? "Error" : "Email Address"}
											helperText={errors.email ? `${errors.email}` : ""}
											variant="outlined"
											required
											fullWidth
											name="email"
											autoComplete="email"
										/>
									</Grid>
									<Grid item xs={12}>
										<TextField
											value={credentials.emailConfirmationCode}
											onChange={(e) => handleChange(e)}
											id={errors.email ? "outlined-error-helper-text" : "emailConfirmationCode"}
											label={errors.email ? "Error" : "Email Confirmation Code"}
											variant="outlined"
											required
											fullWidth
											name="emailConfirmationCode"
											autoComplete="emailConfirmationCode"
										/>
									</Grid>
									<Grid item xs={12} className="register">
										<Button type="submit" variant="contained" color="primary" onClick={(e) => confirmRegister(e)} className="submit red-bck white">
											Confirm
										</Button>
									</Grid>
								</Grid>
							) : (
								<>
									<form className="form" noValidate>
										<TextField
											error={errors.email ? true : false}
											value={credentials.email}
											onChange={(e) => handleChange(e)}
											inputRef={emailRef}
											id={errors.email ? "outlined-error-helper-text" : "email"}
											label={errors.email ? "Error" : "Email Address"}
											helperText={errors.email ? `${errors.email}` : ""}
											variant="outlined"
											margin="normal"
											required
											fullWidth
											name="email"
											autoComplete="email"
										/>
										<TextField
											error={errors.password ? true : false}
											value={credentials.password}
											inputRef={passwordRef}
											onChange={(e) => handleChange(e)}
											id={errors.password ? "outlined-error-helper-text" : "password"}
											label={errors.password ? "Error" : "Password"}
											helperText={errors.password ? `${errors.password}` : ""}
											variant="outlined"
											margin="normal"
											required
											fullWidth
											name="password"
											type="password"
											autoComplete="current-password"
										/>
										{/* <FormControlLabel
                    control={<Checkbox value="remember" color="primary" />}
                    label="Remember me"
                  /> */}
										<div className="actions login">
											<Link component={RouterLink} to="reset-password" className="red bold forgotpass">
												I forgot my password
											</Link>
										</div>
									</form>
									<Button
										type="submit"
										variant="contained"
										className="loginButton red-bck"
										style={{ maxWidth: "fit-content", marginInline: "auto", marginBottom: "20px" }}
										onClick={(e) => handleLogin(e)}
										disabled={props.auth.isLoading}
									>
										{props.auth.isLoading ? "Loading ..." : "Log In"}
									</Button>
									<Divider />
									<div className="ssoButtons">
										<Button
											variant="contained"
											className="googleLoginButton"
											startIcon={!props.auth.isLoading ? <GoogleIcon /> : undefined}
											onClick={(e) => handleFederatedLogIn(e, "Google")}
											disabled={props.auth.isLoading}
										>
											{props.auth.isLoading ? "Loading ..." : "Continue with Google"}
										</Button>
										<Button variant="contained" className="azureLoginButton" onClick={(e) => handleFederatedLogIn(e, "azure-ad")} disabled={props.auth.isLoading}>
											{props.auth.isLoading ? "Loading ..." : "Log in with Azure AD"}
										</Button>
									</div>
								</>
							)}
						</section>
						<Grid container justifyContent="flex-end" className="copyright hidden">
							<Copyright />
						</Grid>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};

export default Login;
